var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_vm.team.name ? _c('h3', [_vm._v("Team: " + _vm._s(_vm.team.name))]) : _vm._e(), _c('team-card'), _c('team-memberships-card'), _c('projects-card'), _c('playgrounds-card', {
    attrs: {
      "playgrounds": _vm.teamPlaygrounds,
      "loading": _vm.loading.teamPlaygrounds,
      "title": "Team Playgrounds"
    },
    on: {
      "refresh": _vm.refreshPlaygrounds
    }
  }), _c('subscriptions-card')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }